import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// Apply saved font size before first render to avoid flash
try {
  const size = localStorage.getItem('sf_font_size');
  if (size) document.documentElement.style.setProperty('--base-font-size', size);
} catch {}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<React.StrictMode><App /></React.StrictMode>);
